import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Dashboard = () => {
  // Mock user plant data
  const myPlants = [
    { id: 1, name: "Monstera Deliciosa", nickname: "Monty", image: "https://images.unsplash.com/photo-1614594975525-e45190c55d40?auto=format&fit=crop&w=200&q=80", nextWater: "Today", health: "Excellent" },
    { id: 2, name: "Snake Plant", nickname: "Snape", image: "https://images.unsplash.com/photo-1593482892290-f54927ae2b7e?auto=format&fit=crop&w=200&q=80", nextWater: "In 5 days", health: "Good" },
    { id: 3, name: "Fiddle Leaf Fig", nickname: "Figgy", image: "https://images.unsplash.com/photo-1597055905081-8cb4275cd3e2?auto=format&fit=crop&w=200&q=80", nextWater: "Tomorrow", health: "Needs Attention" },
  ];

  return (
    <div className="min-h-screen bg-cream py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="flex justify-between items-end mb-10">
          <div>
            <h1 className="text-3xl md:text-4xl font-serif text-botanical-dark mb-2">My Plant Care</h1>
            <p className="text-gray-600">Welcome back, Alex. Here's what your jungle needs today.</p>
          </div>
          <button className="hidden md:flex items-center gap-2 bg-white border border-clay text-clay px-4 py-2 rounded-full hover:bg-clay hover:text-white transition-colors">
            <SafeIcon icon={FiIcons.FiPlus} /> Add Plant
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Main Dashboard Area */}
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm">
              <h2 className="font-serif text-2xl text-botanical-dark mb-6 border-b border-cream-dark pb-4">Watering Schedule</h2>
              
              <div className="space-y-4">
                {myPlants.map(plant => (
                  <div key={plant.id} className="flex items-center justify-between p-4 border border-cream-dark rounded-2xl hover:border-botanical/30 transition-colors">
                    <div className="flex items-center gap-4">
                      <img src={plant.image} alt={plant.name} className="w-16 h-16 rounded-xl object-cover" />
                      <div>
                        <h3 className="font-medium text-botanical-dark">{plant.nickname}</h3>
                        <p className="text-xs text-gray-500">{plant.name}</p>
                      </div>
                    </div>
                    
                    <div className="text-right flex flex-col items-end">
                      <div className={`flex items-center gap-1 text-sm font-medium mb-2 ${plant.nextWater === 'Today' ? 'text-clay' : 'text-botanical'}`}>
                        <SafeIcon icon={FiIcons.FiDroplet} />
                        {plant.nextWater === 'Today' ? 'Water Today' : plant.nextWater}
                      </div>
                      <button className={`text-xs px-4 py-1.5 rounded-full border ${plant.nextWater === 'Today' ? 'bg-clay text-white border-clay' : 'bg-white text-gray-600 border-gray-300 hover:border-botanical'}`}>
                        {plant.nextWater === 'Today' ? 'Mark Watered' : 'Water Anyway'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sidebar Area */}
          <div className="space-y-6">
            
            <div className="bg-botanical text-white rounded-3xl p-6 shadow-sm relative overflow-hidden">
              <div className="absolute top-0 right-0 -mt-6 -mr-6 opacity-20">
                <SafeIcon icon={FiIcons.FiSun} className="w-32 h-32" />
              </div>
              <h3 className="font-serif text-xl mb-2 relative z-10">Weather Alert</h3>
              <p className="text-sm text-cream/80 relative z-10 mb-4">Humidity is dropping in your area. Consider misting your tropicals today.</p>
              <button className="bg-white text-botanical text-sm font-medium px-4 py-2 rounded-full relative z-10 hover:bg-cream transition-colors">
                View Humidity Guide
              </button>
            </div>

            <div className="bg-white rounded-3xl p-6 shadow-sm">
              <h3 className="font-serif text-xl text-botanical-dark mb-4">Quick Tips</h3>
              <ul className="space-y-4 text-sm text-gray-600">
                <li className="flex gap-3">
                  <SafeIcon icon={FiIcons.FiCheckCircle} className="text-clay shrink-0 mt-0.5" />
                  <span>Dust leaves with a damp cloth to help them photosynthesize better.</span>
                </li>
                <li className="flex gap-3">
                  <SafeIcon icon={FiIcons.FiCheckCircle} className="text-clay shrink-0 mt-0.5" />
                  <span>Rotate your plants 90 degrees every week for even growth.</span>
                </li>
              </ul>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Dashboard;